

export const CreateCategoryForm = ({ kanbanPageUid, onSuccess }: { kanbanPageUid: string, onSuccess?: () => void }) => {
    return (
        <div>
            <h1>Create Category Form</h1>
        </div>
    );
};